type GenericObject = { [key: string]: any }

export const ALERT_RULES_LOAD = 'ALERT_RULES_LOAD'
export const alertRulesLoad = (
  accountId: string,
  projectId: string
): AlertRulesLoadAction => ({
  type: ALERT_RULES_LOAD,
  accountId,
  projectId
})

export const ALERT_RULES_LOAD_SUCCESS = 'ALERT_RULES_LOAD_SUCCESS'
export const alertRulesLoadSuccess = (
  accountId: string,
  projectId: string,
  alertRules: GenericObject
): AlertRulesLoadSuccessAction => ({
  type: ALERT_RULES_LOAD_SUCCESS,
  accountId,
  projectId,
  alertRules
})

export const ALERT_RULES_LOAD_FAIL = 'ALERT_RULES_LOAD_FAIL'
export const alertRulesLoadFailure = (
  accountId: string,
  projectId: string,
  error
): AlertRulesLoadFailAction => ({
  type: ALERT_RULES_LOAD_FAIL,
  accountId,
  projectId,
  error
})

export const EDIT_ALERT_RULES = 'EDIT_ALERT_RULES'
export const editAlertRules = (
  accountId: string,
  projectId: string,
  alertRules: GenericObject,
  reload: () => void,
  showSuccessNotification: () => void,
  showFailureNotification: () => void
): EditAlertRulesAction => ({
  type: EDIT_ALERT_RULES,
  accountId,
  projectId,
  alertRules,
  reload,
  showSuccessNotification,
  showFailureNotification
})

export const EDIT_ALERT_RULES_SUCCESS = 'EDIT_ALERT_RULES_SUCCESS'
export const editAlertRulesSuccess = (
  accountId: string,
  projectId: string,
  alertRules: GenericObject
): EditAlertRulesSuccessAction => ({
  type: EDIT_ALERT_RULES_SUCCESS,
  accountId,
  projectId,
  alertRules
})

export const EDIT_ALERT_RULES_FAIL = 'EDIT_ALERT_RULES_FAIL'
export const editAlertRulesFailure = (
  accountId: string,
  projectId: string,
  error: any
): EditAlertRulesFailAction => ({
  type: EDIT_ALERT_RULES_FAIL,
  accountId,
  projectId,
  error
})

export const COPY_ALERT_RULES = 'COPY_ALERT_RULES'
export const copyAndSaveAlertRules = (
  accountId: string,
  projectId: string,
  copyFromProjectId: string,
  reload: () => void,
  showSuccessNotification: () => void,
  showFailureNotification: () => void
): CopyAndSaveAlertRulesAction => ({
  type: COPY_ALERT_RULES,
  accountId,
  projectId,
  copyFromProjectId,
  reload,
  showSuccessNotification,
  showFailureNotification
})

export const COPY_ALERT_RULES_TO_PROJECT_IDS = 'COPY_ALERT_RULES_TO_PROJECT_IDS'
export const copyAlertRulesToProjectIds = (
  accountId: string,
  projectId: string,
  copyToProjectIds: string[],
  allProjectIds: string[],
  reload: () => void,
  showSuccessNotification: () => void,
  showFailureNotification: () => void
): CopyAlertRulesToProjectIdsAction => ({
  type: COPY_ALERT_RULES_TO_PROJECT_IDS,
  accountId,
  projectId,
  copyToProjectIds,
  allProjectIds,
  reload,
  showSuccessNotification,
  showFailureNotification
})

export const GET_ALERT_USAGE_BY_PROJECT = 'GET_ALERT_USAGE_BY_PROJECT'
export const getAlertUsageByProject = (
  accountId: string,
  projectIds: string[]
): GetAlertUsageByProjectAction => ({
  type: GET_ALERT_USAGE_BY_PROJECT,
  accountId,
  projectIds
})

export const GET_ALERT_USAGE_BY_PROJECT_SUCCESS =
  'GET_ALERT_USAGE_BY_PROJECT_SUCCESS'
export const getAlertUsageByProjectSuccess = (
  accountId: string,
  projectIds: string[],
  alertUsageByProject: GenericObject
): GetAlertUsageByProjectSuccessAction => ({
  type: GET_ALERT_USAGE_BY_PROJECT_SUCCESS,
  accountId,
  projectIds,
  alertUsageByProject
})

export const GET_ALERT_USAGE_BY_PROJECT_FAIL = 'GET_ALERT_USAGE_BY_PROJECT_FAIL'
export const getAlertUsageByProjectFailure = (
  accountId: string,
  projectIds: string[],
  error
): GetAlertUsageByProjectFailAction => ({
  type: GET_ALERT_USAGE_BY_PROJECT_FAIL,
  accountId,
  projectIds,
  error
})

// INTERFACEs
export interface AlertRulesLoadAction {
  type: typeof ALERT_RULES_LOAD
  accountId: string
  projectId: string
}

interface AlertRulesLoadSuccessAction {
  type: typeof ALERT_RULES_LOAD_SUCCESS
  accountId: string
  projectId: string
  alertRules: GenericObject
}

interface AlertRulesLoadFailAction {
  type: typeof ALERT_RULES_LOAD_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface EditAlertRulesAction {
  type: typeof EDIT_ALERT_RULES
  accountId: string
  projectId: string
  alertRules: GenericObject
  reload: () => void
  showSuccessNotification: () => void
  showFailureNotification: () => void
}

interface GetAlertUsageByProjectSuccessAction {
  type: typeof GET_ALERT_USAGE_BY_PROJECT_SUCCESS
  accountId: string
  projectIds: string[]
  alertUsageByProject: GenericObject
}
interface GetAlertUsageByProjectFailAction {
  type: typeof GET_ALERT_USAGE_BY_PROJECT_FAIL
  accountId: string
  projectIds: string[]
  error: any
}
export interface CopyAndSaveAlertRulesAction {
  type: typeof COPY_ALERT_RULES
  accountId: string
  projectId: string
  copyFromProjectId: string
  reload: () => void
  showSuccessNotification: () => void
  showFailureNotification: () => void
}
export interface CopyAlertRulesToProjectIdsAction {
  type: typeof COPY_ALERT_RULES_TO_PROJECT_IDS
  accountId: string
  projectId: string
  copyToProjectIds: string[]
  allProjectIds: string[]
  reload: () => void
  showSuccessNotification: () => void
  showFailureNotification: () => void
}
export interface GetAlertUsageByProjectAction {
  type: typeof GET_ALERT_USAGE_BY_PROJECT
  accountId: string
  projectIds: string[]
}
interface EditAlertRulesSuccessAction {
  type: typeof EDIT_ALERT_RULES_SUCCESS
  accountId: string
  projectId: string
  alertRules: GenericObject
}
interface EditAlertRulesFailAction {
  type: typeof EDIT_ALERT_RULES_FAIL
  accountId: string
  projectId: string
  error: any
}
